import { gql } from '@apollo/client';

export const GET_USER_INFO = gql`
  query GetUserInfo {
    user {
      id
      email
      given_name
      family_name
      address
      title
      company {
        id
      }
    }
  }
`;

export const GET_USER_SETTING = gql`
  query GetUserSetting($name: String!) {
    user {
      id
      setting(name: $name)
    }
  }
`;
